<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      钟屋南站<br>
站点介绍<br>
车站位于洲石路和前进二路的交叉口处,沿前进二路南北向敷设。车站设置有7个出入口(A1口预留），其中A口为主要紧急出入口,有盲道及垂直电梯通往站厅,B口为备用紧急出入口。E1口为海上田园东方向公交接驳口，E2口为左炮台东方向公交接驳口。周边主要分布了人人乐超市、桃源居社区、桃源居森林体育公园、大兴商务中心、鹤洲村工业区等多个项目,是钟屋片区文创、娱乐、居住、商业、城市综合体集中区域，客流较为集中，片区出行需求量较大。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:46	23:42	12号线	4分钟	8分钟<br>
海上田园东	06:05	00:01	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:50	23:42	12号线	8分钟	8分钟<br>
海上田园东	06:07	23:30	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
洲石路东北侧、鹤州村工业区<br><br>
B出入口:<br>
洲石路东北侧、易尚三维产业园、南片工业区<br><br>
C出入口:<br>
洲石路西北侧、深圳市宝安区中心医院智荟城社区健康服务中心钟屋泰兴隆工业城<br><br>
D出入口:<br>
洲石路西北侧<br><br>
E1出入口:<br>
洲石路东南侧、桃源居东区、桃源盛景园<br><br>
E2出入口:<br>
洲石路西南侧、桃源大厦、桃源居西区<br>
公交换乘信息<br>

  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>